/* eslint-disable react/no-unknown-property */
/** @jsxImportSource @emotion/react */
import Box from '@mui/material/Box';

const icon = (children) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {children}
  </svg>
);

const ICONS = {
  house: icon(
    <>
      <path d="M3 9L12 2L21 9V20C21 21.1 20.1 22 19 22H5C3.9 22 3 21.1 3 20V9Z" />
      <path d="M9 22V12H15V22" />
    </>
  ),
  grid: icon(
    <>
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
    </>
  ),
  area: icon(
    <>
      <path d="M4 4H20V20H4V4Z" />
      <path d="M4 4L20 20M20 4L4 20" />
    </>
  ),
  sun: icon(
    <>
      <circle cx="12" cy="12" r="5" />
      <path d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22" />
    </>
  ),
  bolt: icon(<path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" />),
  pulse: icon(<path d="M22 12H18L15 21L9 3L6 12H2" />),
};

// Units are glued to the value with no space (342m², 40.0kW); only the yearly
// output is comma separated and marked approximate with a leading tilde.
const SolarPotentialCard = ({ totals, copy, classes, localeCode }) => {
  const numberLocale = (localeCode ?? 'en-GB').replace('_', '-');
  const tiles = [
    { key: 'suitableFaces', icon: ICONS.house, value: totals.suitableFaces },
    { key: 'maxPanels', icon: ICONS.grid, value: totals.maxPanels },
    {
      key: 'usableRoofArea',
      icon: ICONS.area,
      value: `${totals.usableRoofArea}m²`,
    },
    { key: 'avgSunHours', icon: ICONS.sun, value: totals.avgSunHours },
    {
      key: 'systemCapacity',
      icon: ICONS.bolt,
      value: `${totals.systemCapacity.toFixed(1)}kW`,
    },
    {
      key: 'yearlyOutput',
      icon: ICONS.pulse,
      value: `~${totals.yearlyOutput.toLocaleString(numberLocale)}`,
    },
  ];

  return (
    <Box css={classes.potentialCard} data-testid="solarPotentialCard">
      <Box css={classes.potentialTitle}>{copy.solar.potentialTitle}</Box>
      <Box css={classes.potentialGrid}>
        {tiles.map((tile) => (
          <Box
            key={tile.key}
            css={classes.potentialItem}
            data-testid={`solarTile-${tile.key}`}
          >
            <Box css={classes.potentialIcon}>{tile.icon}</Box>
            <Box css={classes.potentialValue}>{tile.value}</Box>
            <Box css={classes.potentialLabel}>{copy.solar.tiles[tile.key]}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SolarPotentialCard;
